import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { CardTitlePrimary } from '@design-system-coopeuch/web';
import { properties } from '../../../../../utils/properties';
import PreguntaEncuestaRadiobutton from '../../../atoms/PreguntaEncuestaRadiobutton';
import PreguntaEncuestaInput from '../../../atoms/PreguntaEncuestaInput';
import { WrapperPregunta } from '../styles';

const Pregunta1 = ({
  setBotonDisabled,
  calificacionRadioButton,
  setCalificacionRadioButton,
  respuestaTexto,
  setRespuestaTexto,
}) => {
  const [habilitarInput, setHabilitarInput] = useState(false);

  useEffect(() => {
    if ((calificacionRadioButton > 0 && !habilitarInput) || (habilitarInput && respuestaTexto.length > 0)) {
      setBotonDisabled(false);
    } else {
      setBotonDisabled(true);
    }
  }, [calificacionRadioButton, respuestaTexto]);

  return (
    <WrapperPregunta>
      <div className="contenido contenido-pregunta1">
        <CardTitlePrimary className="titulo" title={properties.encuestaAbandono.titulo} />
        <div className="pregunta">{properties.encuestaAbandono.pregunta1Titulo}</div>
        <PreguntaEncuestaRadiobutton
          setHabilitarInput={setHabilitarInput}
          setCalificacionRadioButton={setCalificacionRadioButton}
        />
        {habilitarInput &&
          <PreguntaEncuestaInput 
            campoObligatorio
            respuestaTexto={respuestaTexto}
            setRespuestaTexto={setRespuestaTexto}
            maxLength={200}
            labelPrimario={properties.encuestaAbandono.pregunta1Label1}
            labelSecundario=""
            label={1}
          />}
      </div>
    </WrapperPregunta>
  );
};

Pregunta1.propTypes = {
  setBotonDisabled: PropTypes.func.isRequired,
  calificacionRadioButton: PropTypes.number.isRequired,
  setCalificacionRadioButton: PropTypes.func.isRequired,
  respuestaTexto: PropTypes.string.isRequired,
  setRespuestaTexto: PropTypes.func.isRequired
};

export default Pregunta1;
